import { designer } from "@/lib/portfolioData";

export default function Contact() {
  const links = [
    {
      label: "Email",
      value: "chob923@newschool.edu",
      href: `mailto:${designer.socials.email}`,
      testid: "contact-email-link",
      external: false,
    },
    {
      label: "Instagram",
      value: "@rotterywinner_jb",
      href: designer.socials.instagram,
      testid: "contact-instagram-link",
      external: true,
    },
    {
      label: "LinkedIn",
      value: "@mia cho",
      href: designer.socials.linkedin,
      testid: "contact-linkedin-link",
      external: true,
    },
  ];

  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative px-6 md:px-10 lg:px-16 py-28 md:py-40 border-t border-black/10"
    >
      <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-black/60">
        (03) — Contact
      </p>

      <h2
        data-testid="contact-heading"
        className="reveal mt-4 font-display text-6xl md:text-7xl lg:text-8xl leading-[0.9] tracking-tight max-w-5xl"
      >
        <span className="italic text-neon-pink">Contact</span>.
      </h2>

      <ul className="mt-16 md:mt-24 max-w-4xl divide-y divide-black/10 border-y border-black/10">
        {links.map((l, i) => (
          <li key={l.label} className="reveal" style={{ transitionDelay: `${i * 100}ms` }}>
            <a
              href={l.href}
              target={l.external ? "_blank" : undefined}
              rel={l.external ? "noreferrer" : undefined}
              data-testid={l.testid}
              className="group flex items-baseline justify-between gap-6 py-6 md:py-8 transition-colors"
            >
              <span className="font-mono text-[10px] md:text-xs uppercase tracking-[0.22em] text-black/45 group-hover:text-neon-pink transition-colors w-24 md:w-32 shrink-0">
                {l.label}
              </span>
              <span className="flex-1 font-display text-2xl md:text-4xl lg:text-5xl tracking-tight leading-[1] group-hover:italic group-hover:text-neon-pink transition-all duration-300 break-all">
                {l.value}
              </span>
              <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-black/30 group-hover:text-neon-pink transition-colors hidden md:inline-flex items-center gap-2 whitespace-nowrap">
                {l.external ? "Visit ↗" : "Write →"}
              </span>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
